/**
 *   Created by Arif Topcu in 2018
 */
import React, { useCallback } from "react";
import Combobox from "@ls/react-combobox-grid";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAllEntities,
  selectFetchingEntities,
} from "state/selections/selector";
import { addEntityId } from "state/selections/actions";

const columnDefs = [
  {
    headerName: "Entity ID",
    field: "entityId",
    suppressSizeToFit: true,
    width: 75,
  },
  {
    headerName: "Entity",
    field: "label",
    width: 400,
    cellRenderer: (params) => {
      const label = params.value || "";
      const lines = label.split("\n");
      if (lines.length > 1) {
        return `<div>${lines[0]}<br/><span style="color: gray; font-size: 11px; font-weight: normal;">${lines[1]}</span></div>`;
      }
      return label;
    },
  },
  {
    headerName: "Code",
    field: "code",
    width: 100,
  },
  {
    headerName: "GPS ID",
    field: "acId",
    suppressSizeToFit: true,
    width: 75,
  },
];

const EntitySelector = () => {
  const dispatch = useDispatch();
  const entities = useSelector(selectAllEntities);
  const fetchingEntities = useSelector(selectFetchingEntities);
  const onChange = useCallback(
    (values) => {
      dispatch(addEntityId(values));
    },
    [dispatch],
  );

  return (
    <Combobox
      options={entities}
      onChange={onChange}
      value={null}
      loading={fetchingEntities}
      placeholder="Entities..."
      label="Entities:"
      valueKey="entityId"
      labelKey="label"
      columnDefs={columnDefs}
      variation={1}
      multi
    />
  );
};

export default EntitySelector;
